import React, { useCallback, useMemo } from 'react';
import styled, { css } from 'styled-components';

const StyleReceiver = styled.div``;

const Wrapper = styled.div`
  position: relative;

  display: flex;
  justify-content: center;
  align-items: center;

  padding: 0.5em 0.65em;
  border-radius: 100em;
  background-color: var(--swipe-background-color, #51515166);

  font-size: 95%;
`;

const PaginationChipNode = styled.div`
  width: 0.6em;
  height: 0.6em;
  background-color: var(--swipe-dot-background-color, #ffffff4d);
  border-radius: 50%;
  border: 1px solid var(--swipe-dot-border-color, transparent);
  transition: none 200ms ease-in-out;
  transition-property: background-color;
  cursor: pointer;

  &:not(:last-child) {
    margin-right: 0.6em;
  }
`;

type PaginationChipPropsType = {
  className?: string;
  index: number;
  onItemClick?: (index: number) => void;
};
const PaginationChip = ({ className, index, onItemClick }: PaginationChipPropsType) => {
  const onClick = useCallback(
    (e: React.MouseEvent<HTMLDivElement>) => {
      if (onItemClick) {
        e.stopPropagation();

        onItemClick(index);
      }
    },
    [index, onItemClick],
  );
  return <PaginationChipNode className={className} onClick={onClick} />;
};

type PaginationChipNodeType = {
  $isCurrent?: boolean;
};
const StyledPaginationChip = styled(PaginationChip)<PaginationChipNodeType>`
  ${({ $isCurrent = false }) => css`
    ${$isCurrent
      ? css`
          background-color: var(--swipe-dot-active-background-color, white);
        `
      : undefined}
  `}
`;

type SwipePaginationProps = {
  className?: string;
  maxViews: number;
  currIndex: number;
  onItemClick?: (index: number) => void;
};

const SwipePagination = ({ className = '', maxViews, currIndex, onItemClick }: SwipePaginationProps) => {
  const shouldRender = useMemo(
    () => typeof maxViews === 'number' && typeof currIndex === 'number',
    [maxViews, currIndex],
  );

  return shouldRender ? (
    <StyleReceiver className={className}>
      <Wrapper>
        {[...new Array(maxViews).keys()].map((i) => (
          <StyledPaginationChip
            key={`swipe-pagination-chip-${i}`}
            $isCurrent={i === currIndex}
            index={i}
            onItemClick={onItemClick}
          />
        ))}
      </Wrapper>
    </StyleReceiver>
  ) : null;
};

export default SwipePagination;
